<!--
 * @Author: tony.zhu
 * @Date: 2025-10-15 10:00:12
 * @LastEditTime: 2025-11-10 11:12:41
 * @LastEditors: tony.zhu
 * @Description: 
-->

<template>
  <div>
    <el-drawer
      :custom-class="`c-chat_drawer ${
        appendToBody ? 'c-chat_drawer-tobody' : ''
      }`"
      :wrapperClosable="false"
      :size="size"
      :visible.sync="drawerVisible"
      v-bind="$attrs"
      :withFooter="false"
      :modal="false"
      :modal-append-to-body="modalAppendToBody"
      :append-to-body="appendToBody"
    >
      <slot name="content" v-on="$listeners"></slot>
    </el-drawer>
  </div>
</template>

<script>
export default {
  props: {
    drawerVisible: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Number,
      default: 1200,
    },
    modalAppendToBody: {
      type: Boolean,
      default: false,
    },
    appendToBody: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
//@import "styles/index.scss";
</style>

<style lang="scss">
.c-chat_drawer {
  border-radius: 16px;
  // box-shadow: none !important;
  box-shadow: 0px 0px 22px 0px rgba(0, 0, 0, 0.08) !important;
  .el-drawer__header {
    display: none;
  }
  .el-drawer__body{
    padding: 0;
  }
}
</style>